import PropTypes from 'prop-types';

import Calendar from './calendar';
import ArrowWrapper from './arrow-wrapper';

const CalendarLayout = ({arrowParams, dateSelectParams}) => (
  <div className="appointment-container">
    <div className="calendar-bar">
      <h3 className="month">{dateSelectParams.selectedDay.format('MMMM YYYY')}</h3>
    </div>

    <ArrowWrapper {...arrowParams}>
      <Calendar {...dateSelectParams} />
    </ArrowWrapper>
  </div>
);

CalendarLayout.propTypes = {
  arrowParams: PropTypes.object.isRequired,
  dateSelectParams: PropTypes.object.isRequired,
};

export default CalendarLayout;
